angular
  .module("admin.resources")
  .factory("SupervisorResource", (config, $resource) => {
    return $resource(
      config.api + "/api/supervisor",
      {},
      {
        login: {
          method: "POST",
          url: config.api + "/api/v1/auth-backoffice/login",
        },
        changePassword: {
          method: "PATCH",
          url:
            config.api + "/api/v1/backoffice-user-management/change-password",
        },
        impersonate: {
          method: "POST",
          url: config.api + "/api/v1/auth/impersonate-user",
          isArray: false,
        },
      }
    );
  })
  .factory("SubscriptionListResource", (config, $resource) => {
    return $resource(
      config.api + "/api/v1/subscriptions",
      {},
      {
        query: {
          method: "GET",
          url: config.api + "/api/v1/subscriptions/paginated",
          isArray: false,
        },
      }
    );
  })
  .factory("SubscriptionDetailsResource", (config, $resource) => {
    return $resource(
      config.api + "/api/v1/subscriptions",
      {},
      {
        get: {
          method: "GET",
          url: config.api + "/api/v1/subscriptions/:subscriptionNumber/details",
          isArray: false,
        },
        getSubscribers: {
          method: "GET",
          url: config.api + "/api/v1/subscriptions/:subscriptionNumber/subscribers/paginated",
          isArray: false,
        },
        getVindi: {
          method: "GET",
          isArray: false,
          url: config.api + "/api/AdminSubscriptions/GetVindiDetails",
        },
        changeAdmin: {
          method: "PATCH",
          url: config.api + "/api/v1/backoffice-user-management/subscriptions/change-admin",
        },
        getTrials: {
          url: config.api + "/api/Trial/Get",
          method: "GET",
          isArray: true,
        },
      }
    );
  })
  .factory("ChangeCustomerCredentialsResource", (config, $resource) => {
    return $resource(
      config.api + "/api/v1/user-management/users/:id",
      { id: "@id" },
      {
        update: {
          method: "PUT"
        }
      }
    );
  })
  .factory("SubordinateUserResource", (config, $resource) => {
    return $resource(
      config.api + "/api/v1/backoffice-user-management/subordinates/:id",
      { id: "@id" },
      {
        suspend: {
          method: "DELETE",
          url: config.api + "/api/v1/backoffice-user-management/subordinates/:id/suspend",
          params: {
            lang: "pt-BR"
          }
        }
      }
    );
  })
  .factory("VindiResource", (config, $resource) => {
    return $resource(
      config.api + "/api",
      {},
      {
        getCustomer: {
          isArray: false,
          method: "GET",
          url: config.api + "/api/AdminSubscriptions/GetVindiCustomer/:id",
        },
        getSubscription: {
          isArray: false,
          method: "GET",
          url: config.api + "/api/AdminSubscriptions/GetVindiSubscription/:id",
        },
        changeVindi: {
          method: "POST",
          url: config.api + "/api/AdminSubscriptions/ChangeVindi",
        },
      }
    );
  })
  .factory("AdminLogsResource", (config, $resource) => {
    return $resource(
      config.api + "/api/AdminLogs",
      {},
      {
        query: {
          url: config.api + "/api/AdminLogs/GetLogs",
          isArray: false,
        },
      }
    );
  })
  .factory("AdminCustomersResource", (config, $resource) => {
    return $resource(
      config.api + "/api/AdminCustomers/",
      {},
      {
        takedown: {
          method: "GET",
          url: config.api + "/api/AdminCustomers/Takedown/:id",
        },
        deleteCustomer: {
          method: "DELETE",
          url: config.api + "/api/AdminCustomers/delete/:id",
        },
      }
    );
  })
  .factory("TypeaheadResource", (config, $resource) => {
    return $resource(
      config.api + "/api/",
      {},
      {
        customers: {
          url: config.api + "/api/AdminCustomers/Typeahead",
          isArray: true,
          method: "GET",
        },
        supervisors: {
          url: config.api + "/api/Supervisor/Typeahead",
          isArray: true,
          method: "GET",
        },
      }
    );
  })
  .factory("ReportsResource", (config, $resource) => {
    return $resource(
      config.api,
      {},
      {
        basicCustomers: {
          url: config.api + "/api/v1/reports/basic-users-exceeding-views",
          isArray: false,
          method: "GET",
        },
        myce: {
          url: config.api + "/api/adminMyCeReport/GetReport",
          isArray: false,
          method: "GET",
        },
        favoritesChart: {
          url: config.api + "/api/AdminFavoritePostsReport/GetChart",
          isArray: true,
          method: "GET",
        },
        favorites: {
          url: config.api + "/api/AdminFavoritePostsReport/GetReport",
          isArray: false,
          method: "GET",
        },
        revenueReport: {
          url: config.api + "/api/AdminRevenueReport/GetReportData",
          isArray: true,
          method: "GET",
        },
        revenueChart: {
          url: config.api + "/api/AdminRevenueReport/GetChart",
          isArray: false,
          method: "GET",
        },
        futureRevenues: {
          url: config.api + "/api/AdminRevenueReport/GetFutureRevenues",
          isArray: true,
          method: "GET",
        },
        missingRevenues: {
          url: config.api + "/api/AdminRevenueReport/GetMissingSubscriptions",
          isArray: true,
          method: "GET",
        },
        subscriptionFlowCharts: {
          url: config.api + "/api/v1/reports/subscription-flow/charts",
          isArray: false,
          method: "GET",
        },
        subscriptionFlowData: {
          url: config.api + "/api/v1/reports/subscription-flow/data",
          isArray: false,
          method: "GET",
        },
        getMailing: {
          url: `${config.api}/api/AdminMailingReport/GetMailing`,
          method: "GET",
          isArray: true,
        },
        activityLogs: {
          url: `${config.api}/api/v1/activity-logs`,
          method: "GET",
          isArray: false,
        },
      }
    );
  })
  .factory("SubscriptionRevenueResource", (config, $resource) => {
    return $resource(
      config.api + "/api/AdminSubscriptionRevenue",
      {},
      {
        query: { isArray: false },
      }
    );
  })
  .factory("SubscriptionCustomersImport", (config, $resource) => {
    return $resource(
      `${config.api}/api/AdminSubscriptionUpload/CompleteCustomerImport`
    );
  })
  .factory("CampaignsResource", (config, $resource) => {
    return $resource(
      `${config.api}/api/v1/campaigns`,
      {},
      {
        create: {
          method: "POST",
          url: `${config.api}/api/v1/campaigns`,
        },
        update: {
          method: "PUT",
          url: `${config.api}/api/v1/campaigns/:id`,
        },
        query: {
          method: "GET",
        },
        getDetails: {
          url: `${config.api}/api/v1/campaigns/:id/details`,
        },
        get: {
          url: `${config.api}/api/v1/campaigns/:id`,
        },
      }
    );
  })
  .factory("ActivitiesResource", (config, $resource) => {
    return $resource(
      `${config.api}/api/v1/reference-data/professional-activities`,
      {},
      {
        query: {
          method: "GET",
          isArray: false,
        },
      }
    );
  })
  .factory("PlansResource", (config, $resource) => {
    return $resource(
      `${config.api}/api/v1/plans`,
      {},
      {
        query: {
          method: "GET",
          isArray: false,
        },
      }
    );
  })
  .factory("TrialPlans", (config, $resource) => {
    return $resource(`${config.api}/api/admintrial/getplans`);
  })
  .factory("FreePlayResource", (config, $resource) => {
    return $resource(
      `${config.api}/api/v1/free-plays`,
      {},
      {
        query: {
          method: "GET",
          isArray: false,
        },
        get: {
          url: `${config.api}/api/v1/free-plays/subscription/:subscriptionNumber`,
          method: "GET",
          isArray: false,
        },
        delete: {
          url: `${config.api}/api/v1/free-plays/:id`,
          method: "DELETE",
        },
        create: {
          url: `${config.api}/api/v1/free-plays`,
          method: "POST",
        },
        update: {
          url: `${config.api}/api/v1/free-plays/:id`,
          method: "PUT",
        },
      }
    );
  })
  .factory("SupervisorsResource", (config, $resource) => {
    return $resource(
      `${config.api}/api/v1/backoffice-user-management`,
      {},
      {
        query: {
          method: "GET",
          isArray: false,
        },
        toggle: {
          method: "PATCH",
          url: `${config.api}/api/v1/backoffice-user-management/toggle/:id`,
        },
        create: {
          method: "POST",
          url: `${config.api}/api/v1/backoffice-user-management`,
        },
        update: {
          method: "PUT",
          url: `${config.api}/api/v1/backoffice-user-management/:id`,
        },
        changePassword: {
          method: "PATCH",
          url: `${config.api}/api/v1/backoffice-user-management/change-password`,
        },
        changePasswordById: {
          method: "PATCH",
          url: `${config.api}/api/v1/backoffice-user-management/:id/password`,
        },
      }
    );
  });
